import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Alert } from '@grandvisionhq/common';
import { Util, Form } from '@grandvisionhq/forms';
import { useIntl, useSelector, statusLoading, statusFailed } from '@grandvisionhq/state';
import { getAddCall } from '../selectors.js';

const AddAddress = ({ addressForm , onSubmit , className  })=>{
    const { getFormattedLabel  } = useIntl();
    const addCall = useSelector(getAddCall);
    const isAddCallLoading = statusLoading(addCall);
    const isAddCallFailed = statusFailed(addCall);
    const handleSubmit = React.useCallback((state)=>{
        const _ref = Util.getValuesFromState(state.formState), { firstName , lastName , streetName  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
            "firstName",
            "lastName",
            "streetName"
        ]);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(swcHelpers.objectSpread({
            firstName,
            lastName,
            streetName,
            addressTypes: []
        }, rest));
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isAddCallFailed && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        message: getFormattedLabel('checkout.addressBook.newAddress.error', {
            parseLink: true
        })
    }), /*#__PURE__*/ React.createElement(Form, {
        name: "add-address",
        "data-t": "add-address",
        onSubmit: handleSubmit,
        className: classnames('add-address', className)
    }, /*#__PURE__*/ React.createElement("fieldset", {
        disabled: isAddCallLoading,
        className: "add-address__fieldset",
        "data-t": "add-address__fieldset"
    }, addressForm)));
};
var AddAddress$1 = AddAddress;

export { AddAddress$1 as default };
//# sourceMappingURL=AddAddress.js.map
